import { Request } from '@/helpers'
import { COMPONENT_DEFUALT_FILTERS, ENDPOINTS } from '@/data'

const List = async (
    SetState: Function,
    Filters: ComponentFilterClientTypes,
    Components: Array<ComponentInterface>,
    AbortControllerReference: { current: AbortController | null },
    push: Function
) => {
    try {
        if (AbortControllerReference.current) AbortControllerReference.current.abort()
        AbortControllerReference.current = new AbortController()

        SetState({ Loading: true })

        let length = Components.length

        // @ts-ignore
        const { success, data, count } = await Request({
            path: ENDPOINTS.LIST_COMPONENTS,
            method: 'POST',
            signal: AbortControllerReference.current.signal,
            body: {
                tags: Filters?.Tag?.trim() === '' ? [] : [Filters.Tag],
                offset: length,
                price: Filters?.Price,
                category: Filters.Category,
                term: Filters.Term,
                limit: 10,
                checkPurchases: false
            }
        }) as {
            success: boolean,
            data: Array<ComponentInterface>,
            count: number
        }

        if (!AbortControllerReference.current.signal.aborted) {
            if (success) SetState({
                Components: [...Components, ...data],
                Loading: false,
                Error: false,
                HasMore: (length + data.length) < count
            })
        }
    }

    catch (err: any) {
        if (err?.message?.includes('aborted')) return

        else SetState({
            Components: [],
            Loading: true,
            Error: false,
            Deleting: null,
            HasMore: true,
            Filters: COMPONENT_DEFUALT_FILTERS
        })
    }
}

export default List
